import {Injectable} from '@angular/core';
import {map} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {ResultListApiModel} from "../models/result-list.api.model";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {environment} from "../../../environments/environment";
import {plainToClass, plainToClassFromExist} from "class-transformer";
import {BugReportApiModel} from "../models/bug-report.api-model";
import {QueryParamsService} from "../../core/services/query-params.service";
import {QueryParamsApiModel} from "../models/query-params-api.model";

@Injectable()
export class BugReportRestService {
  private readonly resource: string = '/bug_reports';

  constructor(
    private http: HttpClient,
    public params: QueryParamsService
  ) {
  }

  public create(reportAM: BugReportApiModel): Observable<BugReportApiModel> {
    return this.http.post<BugReportApiModel>(environment.apiUrl + this.resource, reportAM)
      .pipe(map((result: BugReportApiModel) => plainToClass(BugReportApiModel, result)))
  }

  public get(id: string, queryParamsApiModel: QueryParamsApiModel = new QueryParamsApiModel()): Observable<BugReportApiModel> {
    const params = this.params.applyParameters(queryParamsApiModel);
    return this.http.get<BugReportApiModel>(environment.apiUrl + this.resource + '/' + id, {params})
      .pipe(map((result: BugReportApiModel) => plainToClass(BugReportApiModel, result)))
  }

  public patch(id: string, data: Partial<BugReportApiModel>): Observable<BugReportApiModel> {
    return this.http.patch<BugReportApiModel>(environment.apiUrl + id, data)
      .pipe(map((result: BugReportApiModel) => plainToClass(BugReportApiModel, result)));
  }

  public delete(id: string): Observable<void> {
    return this.http.delete<void>(environment.apiUrl + id);
  }

  public getCollection(
    queryParamsApiModel: QueryParamsApiModel = new QueryParamsApiModel(),
    options: { headers?: HttpHeaders } = {}
  ): Observable<ResultListApiModel<BugReportApiModel>> {
    const params = this.params.applyParameters(queryParamsApiModel);
    return this.http.get<ResultListApiModel<BugReportApiModel>>(environment.apiUrl + this.resource, {params, ...options})
      .pipe(map(result => plainToClassFromExist(new ResultListApiModel<BugReportApiModel>(BugReportApiModel), result as object)));
  }
}
